import { fromTheme } from '@kyruus/ui-theme';
import styled from '@emotion/styled';

import LocationVideo from '../../Video';

export const Lists = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${fromTheme('spacing_xlarge')};
  margin-bottom: ${fromTheme('spacing_large')};
`;

export const ListSection = styled.div`
  width: 30%;
  min-width: 300px;

  @media (max-width: ${fromTheme('screen_medium')}) {
    width: 50%;
  }

  @media (max-width: ${fromTheme('screen_small')}) {
    width: 100%;
  }
`;

export const Description = styled.p`
  white-space: pre-wrap;
  color: ${fromTheme('color_text')};
`;

export const Video = styled(LocationVideo)`
  margin: ${fromTheme('spacing_medium')} 0;
  max-width: 560px;
`;

export const ListSectionHeader = styled.h3`
  font-size: ${fromTheme('font_size_heading_5')};
  font-family: ${fromTheme('font_face')};
  color: ${fromTheme('color_text')};
  line-height: ${fromTheme('font_line_height')};
  display: block;
  font-weight: bold;
  margin-bottom: ${fromTheme('spacing_medium')};
`;

const SummaryBlockList = styled.ul`
  list-style: none;
  padding: 0;
  font-size: ${fromTheme('font_size')};
  font-family: ${fromTheme('font_face')};
  color: ${fromTheme('color_text')};
  line-height: ${fromTheme('font_line_height')};
`;
const SummaryBlockListItem = styled.li`
  line-height: ${fromTheme('font_line_height')};
  display: flex;
  word-break: break-word;
  justify-content: start;
  gap: ${fromTheme('spacing_small')};
`;

const SummaryBlockListItemTitle = styled.div`
  display: inline-block;
  min-width: 80px;
`;

export const HourList = styled(SummaryBlockList)`
  white-space: nowrap;
`;
export const HourItem = styled(SummaryBlockListItem)<{ isToday: boolean }>`
  font-weight: ${({ isToday }) =>
    isToday ? fromTheme('font_weight_bolder') : fromTheme('font_weight')};
`;
export const HourItemTitle = styled(SummaryBlockListItemTitle)``;

export const ContactList = styled(SummaryBlockList)``;
export const ContactItem = styled(SummaryBlockListItem)``;
export const ContactItemTitle = styled(SummaryBlockListItemTitle)``;
export const AccessibilityList = styled(SummaryBlockList)`
  list-style: disc;
  margin-left: ${fromTheme('spacing_medium')};
`;
export const AccessibilityListItem = styled(SummaryBlockListItem)`
  display: list-item;
`;
